<template>
  <Head>
    <title>Announcements | NutriStudents K-12</title>
    <meta name="description" content="Announcements">
  </Head>
  <default-layout>
    <BreadcrumLayout>
      <U>Settings</U>
    </BreadcrumLayout>
    <PageTitleLayout>
      <div class="lg:mb-0 mb-4 w-1/2">
        <h1 class="heading-color xl:text-4xl text-2xl font-bold">Announcements</h1>
      </div>
      <div class="w-full flex lg:flex-nowrap flex-wrap justify-end items-center">
        <button>
          <inertia-link :href="route('announcements.add')"
            class="button-color text-white font-bold py-3 xl:px-4 px-2 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 mt-10  inline-block uppercase">
            Create Announcement
          </inertia-link>
        </button>
      </div>
    </PageTitleLayout>

    <TableFilterLayout @messageFromChild="newsSearchData" />

    <TableIndexLayout>
      <div class="-my-2">
        <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full">
          <div class="shadow">
            <table class="min-w-full">
              <thead class="header-bg-color">
                <tr>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    Title
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    Published At
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    Expires At
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    Status
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!news_items.length" class="bg-white">
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="5">No Announcements Found</td>
                </tr>

                <tr v-for="(news, index) in news_items"
                  :key="news.id"
                  :class="{ 'bg-white': index % 2 == 0, 'tr-background-color': index % 2 != 0 }">
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
                    {{ news.title }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
                    {{ news.show_publish }}
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
                    {{ news.show_expires }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
                    <span v-if="news.is_archived" class="text-red-600 font-bold uppercase">Archived</span>
                    <span v-else-if="news.is_scheduled" class="text-yellow-600 font-bold uppercase">Scheduled</span>
                    <span v-else class="text-green-600 font-bold uppercase">Published</span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap id-color text-xl font-extrabold text-right">
                    <inertia-link :href="route('announcements.edit', { news: news.id })" class="pr-3">
                      <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </inertia-link>
                    <button type="button" @click="duplicateNews(news.id)" class="text-blue-500 pr-3" title="Duplicate">
                      <i class="fa fa-files-o" aria-hidden="true"></i>
                    </button>
                    <button type="button" @click="archiveNews(news.id)" v-if="!news.is_archived" class="text-orange-500 pr-3" title="Archive">
                      <i class="fa fa-archive" aria-hidden="true"></i>
                    </button>
                    <button type="button" @click="deleteNews(news.id)" class="text-red-500" title="Delete">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </TableIndexLayout>
  </default-layout>
</template>

<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";

export default {
  props: ['news_data'],
  components: {
    DefaultLayout,
    BreadcrumLayout,
    PageTitleLayout,
    TableFilterLayout,
    TableIndexLayout,
  },
  data() {
    return {
      searchTerm: '',
    }
  },
  computed: {
    news_items() {
      if (this.searchTerm === "") {
        return this.news_data;
      }
      const term = this.searchTerm.toLowerCase();
      return this.news_data.filter(item => 
        item.title.toLowerCase().includes(term) || 
        item.body.toLowerCase().includes(term)
      );
    }
  },
  methods: {
    archiveNews(id) {
      if (confirm("Are you sure you want to archive this Announcement?")) {
        this.$inertia.post(this.route('announcements.archive', id), {}, {
          onSuccess: () => {
            this.$toast.success('Announcement archived successfully!');
          }
        });
      }
    },
    duplicateNews(id) {
      if (confirm("Are you sure you want to duplicate this Announcement?")) {
        this.$inertia.post(this.route('announcements.duplicate', id), {}, {
          onSuccess: () => {
            this.$toast.success('Announcement duplicated successfully!');
          }
        });
      }
    },
    deleteNews(id) {
      if (confirm("Are you sure you want to delete this Announcement? (This is a soft delete)")) {
        this.$inertia.post(this.route('announcements.destroy', id), {}, {
          onSuccess: () => {
            this.$toast.success('Announcement deleted successfully!');
          }
        });
      }
    },
    newsSearchData(search) {
      this.searchTerm = search;
    },
  },
};
</script>
